import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'any'
})
export class ToasterServiceService {
  private snackBar = inject(MatSnackBar);

  showSuccess(message: string) {
    
    this.show(message, 'my-custom-snackbar');
  }
  
  showInfo(message: string) {
  this.show(message, 'my-custom-info-snackbar');
  }

  showError(message: string) {
    this.show(message, 'my-custom-error-snackbar');
  }
  private show(message: string, panelClass: string) {
    this.snackBar.dismiss();
   return this.snackBar.open(message, 'Close', {
       duration: 3000, 
      
      verticalPosition: 'top',
      horizontalPosition: 'end',
      panelClass: [panelClass],
    });
  }
  }

